<template>
  <div>
    <template default="header">
			
      <Row
        justify="end"
        v-if="this.rows.resType !== 1"
        style="width: 100%; margin-bottom: 10px"
      >
				<Col span="7">
					<div style="display: flex;">
							<Select :max-tag-count="2" filterable clearable multiple v-model="agent_id" >
								<Option v-for="item in AllAgentList" :value="item.value" :key="item.value">{{ item.label }}</Option>
							</Select>
							<Button style="margin: 0 20px;" @click="batchAdd" size="small" type="primary">
							  {{ $t("batch") + $t("add") }}
							</Button>
					</div>
				</Col>
        <Col span="3">
					<Button :disabled="isDel" v-if="$hasPermission([1292,1291,1290,1289])" @click="del" style="margin-right: 10px;" size="small" type="error">
						{{ $t('batch')+ $t("delete") }}
					</Button>
          <Button @click="packBtn" size="small" type="primary">
            {{ $t("packing") + $t("information") }}
          </Button>
        </Col>
        <Col span="2">
          {{ $t("invoicePCS") }}:
          <span style="margin-left: 10px; font-size: 16px; font-weight: bold">
            {{ quantity }}件
          </span>
        </Col>
				<Col span="3">
				  {{ $t("actualChargeWeight") }}:
				  <span style="margin-left: 10px; font-size: 16px; font-weight: bold">
				    {{ actual_weight }}kg
				  </span>
				</Col>
        <Col span="3">
          {{ $t("skuVolume") }}:
          <span style="margin-left: 10px; font-size: 16px; font-weight: bold">
            {{ volume }}CBN
          </span>
        </Col>
        <Col span="3">
          {{ $t("skuVolume") + $t("Weight") }}:
          <span style="margin-left: 10px; font-size: 16px; font-weight: bold">
            {{ volume_weight }}kg
          </span>
        </Col>
        <Col v-if="rows.resType == 3" span="3">
          {{ $t("Billing") + $t("Weight") }}:
          <span style="margin-left: 10px; font-size: 16px; font-weight: bold">
            {{ charging_weight }}kg
          </span>
        </Col>
      </Row>
			<div v-else style="display: flex;align-items: center;margin-bottom: 10px;">
					<Select :max-tag-count="5" filterable clearable multiple v-model="agent_id" style="width: 500px;">
						<Option v-for="item in AllAgentList" :value="item.value" :key="item.value">{{ item.label }}</Option>
					</Select>
					<Button style="margin: 0 20px;" @click="batchAdd" size="small" type="primary">
					  {{ $t("batch") + $t("add") }}
					</Button>
					<Button :disabled="isDel" v-if="$hasPermission([1292,1291,1290,1289])" @click="del" size="small" type="error">
						{{ $t('batch')+ $t("delete") }}
					</Button>
			</div>
    </template>
    <cTable
      ref="table"
      :fields="fields"
      :methods="methods"
      :modals="modals"
      :config="config"
      :footer="footer"
			@checkTable="(e)=>isDel = !e.length"
    ></cTable>
		<div style="text-align: right;margin-top: 10px;">
			<Button type="primary" @click="save">{{$t('save')+$t('finalCost')}}</Button>
		</div>
  </div>
</template>

<script>
import {
  getCost,
  getConfig,
  addCost,
  updateCost,
  deleteCost,
  getWeight,
  getPackingInfo,
  getAirAgent,
  getCostValue,
  getSubjectCost,
	batchDel,
	batchSave,
	getRule,
	getAgentList
} from "@/api/tracker/cost_page";
import { getTransportAgent, getZhongGangByClient } from "@/api/tracker/air";
import { getExpense } from "@/api/finance/expense";
import numFun from "@/utils/numFun";
import cTable from "@/base/common/index";
import { getAgent } from "@/api/tracker/agent";
export default {
  components: {
    cTable,
  },
  props: {
    rows: {
      type: Object,
    },
		height: {
		  type: Number,
			default:700,
		},
  },
	inject:['$page'],
  data() {
    let that = this;
    return {
      loading: false,
			AllAgentList:[],
			agent_id:[],
      list: [],
      expenseList: [],
      currencyList: [],
      bubbleList: [],
      searchData: {},
      unitList: [],
      agentList: [],
      charging_weight: 0,
      actual_weight: 0,
      volume_weight: 0,
      quantity: 0,
      volume: 0,
			isDel:true,
      totalAmount: [],
      methods: {
				
        list: (p) => {
          p["extract_id"] = this.rows.id;
          p["type"] = this.rows.resType;
          return getCost(p);
        },
        beforeHandleList: ({ data }) => {
          this.totalAmount = [];
          for (const key in data.count) {
            this.totalAmount.push({
              text: this.$t("total"),
              replace_currency: key,
              total_amount: data.count[key],
            });
          }
          data.rows.unshift({
            expense_item: [],
            currency: that.currencyList.length
              ? that.currencyList[0].value
              : "",
            unit: "",
            amount: 0,
            operator_name: "-",
            create_time: "-",
            remarks: "",
            price: 0,
            charging_value: 0,
            bubble: that.bubbleList.length ? that.bubbleList[0].value : "",
          });
          return data.rows;
        },
        getConfig,
        addCost,
        updateCost,
        deleteCost,
        getWeight,
        getTransportAgent,
        getZhongGangByClient,
        getPackingInfo,
        getSubjectCost,
      },
      modals: {
        show: {
          config: {
            modalBind: {
              width: 90,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 700,
            },
            fields: [
              {
                name: () => this.$t("packing_number"),
                key: "packing_number",
                tooltip: true,
                minWidth: 120,
              },
              {
                name: () => this.$t("number_of_bags"),
                key: "quantity",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("skuVolume"),
                key: "volume",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("charge_volume"),
                key: "volume_weight",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("actual_weight"),
                key: "actual_weight",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
      },
      config: {
				height: this.height,
        slot: "div",
        resize: false,
        showOverflow: false,
        // showFooter: true,
        // footerCellClassName: "col-red",
        // footerMethod: ({ columns, data }) => {
        //   const sums = [];
        //   columns.forEach(column => {
        //     let sumCell = null;
        //     switch (column.property) {
        //       case "operator_name":
        //         sumCell = this.$t("total");
        //         break;
        //       case "price":
        //         sumCell = sumCell = numFun.sumNumFun(data, column.property, 2);
        //         break;
        //       case "amount":
        //         sumCell = sumCell = numFun.sumNumFun(data, column.property, 2);
        //         break;
        //       default:
        //         sumCell = "-";
        //         break;
        //     }
        //     sums.push(sumCell);
        //   });
        //   // 返回一个二维数组的表尾合计
        //   return [sums];
        // }
      },
      footer: {
        show: () => false,
        render: (h) => {
          return h(
            "div",
            {
              class: "footer-content",
            },
            this.totalAmount.map((item) => {
              return h(
                "div",
                {
                  class: "footer-content-item",
                },
                [
                  h("span", { class: "span-head" }, item.text),
                  h(
                    "span",
                    { class: "span-head" },
                    item.replace_currency + ":"
                  ),
                  h(
                    "span",
                    {
                      class: "span-title",
                    },
                    numFun.formatNum(parseFloat(item.total_amount))
                  ),
                ]
              );
            })
          );
        },
      },
      fields: [
				{
				  type: "checkbox",
				  width: 60,
				  fixed: "left",
				},
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          // component: "Input",
          placeholder() {
            return this.$t("operate");
          },
          width: 100,
          disabled: true,
        },
        {
          name: () => this.$t("operation") + this.$t("time"),
          key: "create_time",
          // component: "Input",
          placeholder() {
            return this.$t("operation") + this.$t("time");
          },
          width: 150,
          disabled: true,
        },
        {
          name: () => this.$t("agentName"),
          key: "agent_id",
          component({row}){
						return row.bill_id > 0?'span':"Select"
					},
          placeholder() {
            return this.$t("select") + this.$t("agentName");
          },
          options: [],
          disabled({ row }) {
            return row.bill_id > 0;
          },
					methods:{
						render({field,value}){
							return (field.options.find(t=>t.value === value) || {}).label || '-'
						}
					}
        },
        {
          name: () => this.$t("Odd_Numbers"),
          key: "packing_id",
          align: "left",
          placeholder: () => {
            return this.$t("select") + this.$t("Odd_Numbers");
          },
          show: () => this.rows.resType != 1,
          minWidth: 100,
          options: [],
          disabled({ row }) {
            return row.bill_id > 0;
          },
					component({row}){
						return row.bill_id > 0?'span':"Select"
					},
          methods: {
						render({field,value}){
							return (field.options.find(t=>t.value === value) || {}).label || '-'
						},
            "on-change"({ value, row }) {
              if (value && row["unit"]) {
                let data = {
                  extract_id: that.rows.id,
                  type: that.rows.resType,
                  packing_id: value,
                  unit: row["unit"],
                  bubble: row["unit"] == 4 ? row["bubble"] : "",
                };
                getCostValue(data).then((res) => {
                  row["charging_value"] = res.data.payload;
                });
              }
            },
          },
        },
        {
          name: () => this.$t("expense"),
          key: "expense_item",
          minWidth: 120,
          component: "Cascader",
          placeholder() {
            return this.$t("select") + this.$t("expense");
          },
          options: [],
          disabled({ row }) {
            return row.bill_id > 0;
          },
					default:[],
          methods: {
            async loadData({ item, callback }) {
              item.loading = true;
              item.children = (
                await getSubjectCost({ pid: item.value })
              ).data.payload;
              item.loading = false;
              callback();
            },
          },
        },
        // {
        //   name: () => this.$t("data") + this.$t("source"),
        //   key: "source",
        //   component: "Select",
        //   placeholder() {
        //     return this.$t("select") + this.$t("data") + this.$t("source");
        //   },
        //   options: [],
        //   show: () => this.rows.resType != 1
        // },
        {
          name: () => this.$t("Billing") + this.$t("mode"),
          key: "unit",
          component: "Select",
          placeholder() {
            return this.$t("select") + this.$t("Billing") + this.$t("mode");
          },
          options: [],
          show: () => this.rows.resType != 1,
          disabled({ row }) {
            return row.bill_id > 0;
          },
					component({row}){
						return row.bill_id > 0?'span':"Select"
					},
          methods: {
						render({field,value}){
							return (field.options.find(t=>t.value === value) || {}).label || '-'
						},
            "on-change"({ value, row }) {
              if (value && row["packing_id"]) {
                let data = {
                  extract_id: that.rows.id,
                  type: that.rows.resType,
                  packing_id: row["packing_id"],
                  unit: value,
                  bubble: value == 4 ? row["bubble"] : "",
                };
                getCostValue(data).then((res) => {
                  row["charging_value"] = res.data.payload;
                });
              }
            },
          },
        },
        {
          name: () => this.$t("Billing") + this.$t("number"),
          key: "charging_value",
          disabled: ({ row }) => {
            return !row.unit || !row.packing_id || row.bill_id > 0;
          },
          show: () => this.rows.resType != 1,
          placeholder() {
            return this.$t("Billing") + this.$t("number");
          },
					component({row}){
						return !row.unit || !row.packing_id || row.bill_id > 0?'span':"Input"
					},
        },
        {
          name: () =>
            that.rows.resType == 1
              ? this.$t("cost_fee")
              : this.$t("doublePrice"),
          key: "price",
          disabled({ row }) {
            return row.bill_id > 0;
          },
          placeholder() {
            return this.$t("enter") + this.$t("operate");
          },
					component({row}){
						return row.bill_id > 0?'span':"Input"
					},
        },
        {
          name: () => this.$t("bubble_weight"),
          key: "bubble",
          placeholder() {
            return this.$t("select") + this.$t("bubble_weight");
          },
          options: [],
          show: () => this.rows.resType != 1,
          disabled: ({ row }) => {
            return row["unit"] != 4 || row.bill_id > 0;
          },
					component({row}){
						return row["unit"] != 4 || row.bill_id > 0?'span':"Select"
					},
          methods: {
						render({field,value}){
							return (field.options.find(t=>t.value === value) || {}).label || '-'
						},
            "on-change"({ value, row }) {
              if (value && row["packing_id"] && row["unit"]) {
                let data = {
                  extract_id: that.rows.id,
                  type: that.rows.resType,
                  packing_id: row["packing_id"],
                  unit: row["unit"],
                  bubble: value,
                };
                getCostValue(data).then((res) => {
                  row["charging_value"] = res.data.payload;
                });
              }
            },
          },
        },
        {
          name: () => this.$t("cost_fee"),
          key: "amount",
          placeholder() {
            return this.$t("enter") + this.$t("cost_fee");
          },
          options: [],
          show: () => this.rows.resType != 1,
        },
        {
          name: () => this.$t("calculation") + this.$t("currency_t"),
          key: "currency",
          placeholder() {
            return (
              this.$t("select") + this.$t("calculation") + this.$t("currency_t")
            );
          },
          options: [],
          disabled({ row }) {
            return row.bill_id > 0;
          },
					component({row}){
						return row.bill_id > 0?'span':"Select"
					},
					methods:{
						render({field,value}){
							return (field.options.find(t=>t.value === value) || {}).label || '-'
						},
					}
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          placeholder() {
            return this.$t("enter") + this.$t("Remarks");
          },
          disabled({ row }) {
            return row.bill_id > 0;
          },
					component({row}){
						return row.bill_id > 0?'span':"Input"
					},
        },
        {
          name: () => this.$t("bill_type"),
          key: "bill_type",
          disabled: true,
          methods: {
            render({ row }) {
              return row.bill_id > 0 ? this.$t("disable") : this.$t("enable");
            },
          },
        },
        {
          type: "btns",
          width: 160,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name(obj) {
								return this.$t('add')
                return obj && obj.rowIndex == 0
                  ? this.$t("order_submit")
                  : this.$t("update");
              },
              disabled({ row }) {
                return row.bill_id > 0;
              },
              type: "add",
              fnName: "add",
              bind: {
                type: (obj) =>
                  obj && obj.rowIndex == 0 ? "success" || "warning" : "success",
              },
              icon: (obj) =>
                obj && obj.rowIndex == 0 ? "md-add" : "md-add" || "ios-create-outline",
              id: [833, 834, 841, 842, 864, 865,1286,1287],
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              icon: "md-trash",
              // show(obj) {
              //   return obj && obj.rowIndex != 0;
              // },
              disabled({ row }) {
                return row.bill_id > 0;
              },
              id: [835, 843, 863,1285],
            },
          ],
          methods: {
            add() {
              // console.log(this);
							this.list.unshift({
								expense_item: [],
								currency: that.currencyList.length
									? that.currencyList[0].value
									: "",
								unit: "",
								amount: 0,
								operator_name: "-",
								create_time: "-",
								remarks: "",
								price: 0,
								charging_value: 0,
								bubble: that.bubbleList.length ? that.bubbleList[0].value : "",
							})
              // let data = row;
              // delete data.operator_name;
              // data.type = that.rows.resType;
              // data.extract_id = that.rows.id;
              // this.handleRequestMethods(
              //   row.id ? "updateCost" : "addCost",
              //   data,
              //   true,
              //   true
              // ).then((res) => {
              //   this.getList();
              // });
            },
            delete({ row,rowIndex,methods }) {
							if(!row.id){
								this.list.splice(rowIndex,1)
								if(!this.list.length)methods.add.call(this)
								return
							}
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "deleteCost",
                    row.id,
                    true,
                    true
                  ).then((res) => {
                    this.getList();
										if(!this.list.length){
											field.methods.add.call(this)
										}
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
  async mounted() {
    this.loading = true;
    let config = (await getConfig()).data.payload;
    this.expenseList = (await getSubjectCost({ pid: 0 })).data.payload;
    this.agentList = (
      await getAirAgent({ id: this.rows.id, type: this.rows.resType })
    ).data.payload;
    if (this.rows.resType != 1) {
      this.zhonggangList = (
        await getZhongGangByClient({
          id: this.rows.id,
          type: this.rows.resType,
        })
      ).data.payload;
    }
    this.currencyList = config.currency;
    this.bubbleList = config.bubble;
    this.unitList = config.unit;
		this.AllAgentList = (await getAgentList()).data.payload;
    if (this.rows.resType != 1) {
      getWeight({ id: this.rows.id, type: this.rows.resType }).then((res) => {
        this.actual_weight = res.data.payload.actual_weight;
        this.volume_weight = res.data.payload.volume_weight;
        this.volume = res.data.payload.volume;
        this.quantity = res.data.payload.quantity;
        this.charging_weight = res.data.payload.charging_weight;
      });
    }
    this.fields.forEach((el) => {
      if (el.key == "expense_item") el.options = this.expenseList;
      if (el.key == "unit") el.options = this.unitList;
      if (el.key == "currency") el.options = this.currencyList;
      if (el.key == "bubble") el.options = this.bubbleList;
      if (el.key == "agent_id") el.options = this.agentList;
      if (this.rows.resType != 1 && el.key == "packing_id")
        el.options = this.zhonggangList;
      if (this.rows.resType != 1 && el.key == "source") {
        el.options = [
          {
            label: this.$t("extract"),
            value: "extract",
          },
          {
            label: this.$t("packing"),
            value: "packing",
          },
        ];
      }
    });
    console.log(this.fields);
    if (this.$refs["table"]) {
      this.$refs["table"].list[0]["currency"] = this.currencyList.length
        ? this.currencyList[0].value
        : "";
      this.$refs["table"].list[0]["bubble"] = this.bubbleList.length
        ? this.bubbleList[0].value
        : "";
    }
    this.loading = false;
  },
  methods: {
		batchAdd(){
			this.$page.openLoading();
			getRule({
				extract_id:this.rows.id,
				type:this.rows.resType,
				agent_id:this.agent_id
			}).then(res=>{
				this.agent_id = []
				console.log(res);
				 this.$page.closeLoading();
				if(res.data.status){
					res.data.payload.map(t=>{
						this.$refs['table'].list.push(t)
					})
				}
			}).catch(err=>{
				 this.$page.closeLoading();
			})
		},
		save(){
			batchSave({
				extract_id:this.rows.id,
				type:this.rows.resType,
				cost:this.$refs['table'].list
			}).then(res=>{
				if(res.data.status){
					this.$Message["success"]({
						background: true,
						content: res.data.msg
					});
					this.$refs['table'].getList();
				}
			})
		},
		del(){
			this.$Modal.confirm({
				title: this.$t("delete"),
				width: 300,
				content: this.$t("titleModal"),
				onOk: () => {
					batchDel({ids:this.$refs['table'].selectAll.map(t=>t.id).filter(t=>t)}).then(res => {
						if(res.data.status){
							this.$Message["success"]({
								background: true,
								content: res.data.msg
							});
							this.$refs['table'].getList();
						}
						
					});
				}
			});
		},
    packBtn() {
      let that = this;
      this.$refs["table"].getModal("show").open(null, function () {
        this.setTitle(
          this.$t("packing") + this.$t("information") + that.rows.mawb
        );
        getPackingInfo({ id: that.rows.id, type: that.rows.resType }).then(
          (res) => {
            this.list = res.data.payload;
          }
        );
      });
    },
  },
};
</script>
